import * as Effects from 'redux-saga/effects'
import { select } from 'redux-saga/effects'
import {
  EventActions,
  RoomActions,
} from '../../reducers/bookingCalendar/actionNames'
import { ReservationsListActions } from '../../reducers/reservationsList/actionNames'
import {
  getReservationsListCanceledEvents,
  getReservationsListDeletedEvents,
  getReservationsListNewEvents,
} from '../../reducers/reservationsList/selectors'

export function* getEvents() {
  const canceled = yield select(getReservationsListCanceledEvents)
  const allEvents = yield select(getReservationsListNewEvents)
  const deletedEvents = yield select(getReservationsListDeletedEvents)

  yield Effects.put({
    canceledReservations: [...canceled],
    newReservations: [...allEvents],
    deletedReservations: [...deletedEvents],
    type: ReservationsListActions.SetReservations,
  })
}

export default function*() {
  yield Effects.takeLatest(
    [
      ReservationsListActions.SetDate,
      EventActions.DataForEventsAccepted,
      ReservationsListActions.LoadList,
      EventActions.EventWasDeleted,
      RoomActions.DataForRoomsAccepted,
    ],
    getEvents,
  )
}
